/**
 * CreatePromptFAB - Floating Action Button for creating prompts
 * Positioned to work alongside ScrollToTop button
 * Shows for all users - protected route handles auth
 */

import { useNavigate, useLocation } from 'react-router-dom';

interface CreatePromptFABProps {
  className?: string;
}

export default function CreatePromptFAB({ className = '' }: CreatePromptFABProps) {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on create prompt page or auth pages
  const hideOnPaths = ['/prompts/create', '/login', '/register', '/auth'];
  const shouldHide = hideOnPaths.some(path => location.pathname.startsWith(path));

  if (shouldHide) {
    return null;
  }

  const handleClick = () => {
    navigate('/prompts/create');
  };

  return (
    <button
      onClick={handleClick}
      className={`
        fixed bottom-6 right-6 z-50
        w-12 h-12
        bg-primary-600 hover:bg-primary-700
        text-white
        rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-300 ease-in-out
        transform hover:scale-110 active:scale-95
        focus:outline-none focus:ring-4 focus:ring-primary-300 focus:ring-opacity-50
        group
        ${className}
      `}
      aria-label="Create new prompt"
      title="Create new prompt"
    >
      <div className="flex items-center justify-center h-full">
        <svg
          className="w-6 h-6 transform transition-transform duration-300 group-hover:rotate-90"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M12 4v16m8-8H4"
          />
        </svg>
      </div>

      <div className="absolute inset-0 rounded-full bg-primary-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300 animate-pulse"></div>
    </button>
  );
}
